import { ErrorOutline, Icon, Panel, Stack, Text } from '@/ui';
import { Inline } from '@/ui/layout/Inline';
import { toTitleCaseWords } from './errorStateTitle';
import type { SxProps, Theme } from '@/ui/primitives/types';
import type { SvgIconComponent } from '@/ui/primitives/types';
import type { ReactElement, ReactNode } from 'react';

type ErrorStatePanelProps = {
  title: string;
  body?: ReactNode;
  actions?: ReactNode;
  icon?: SvgIconComponent;
  sx?: SxProps<Theme>;
};

export const ErrorStatePanel = ({
  title,
  body,
  actions,
  icon: StateIcon = ErrorOutline,
  sx,
}: ErrorStatePanelProps): ReactElement => (
  <Panel actions={actions} actionsAlign="center" sx={sx}>
    <Stack gap="md" align="center" sx={{ width: '100%', textAlign: 'center' }}>
      <Inline
        gap="md"
        justify="center"
        wrap="nowrap"
        sx={{ width: 'auto', maxWidth: '100%', alignItems: 'center' }}
      >
        <Icon size="lg">
          <StateIcon color="error" aria-hidden="true" focusable="false" />
        </Icon>
        <Text role="sectionTitle" sx={{ minWidth: 0, textAlign: 'left' }}>
          {toTitleCaseWords(title)}
        </Text>
      </Inline>
      {typeof body === 'string' ? (
        <Text role="bodyMuted" align="center">
          {body}
        </Text>
      ) : (
        body
      )}
    </Stack>
  </Panel>
);
